var map = {
	"./": 18305,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Assets/Images/148-1484366_saturday-october-19-red-right-arrow-png.png": 8341,
	"./Assets/Images/724-7247376_search-bar-magnifying-glass-hd-png-download.png": 76716,
	"./Assets/Images/breakfast.jpg": 751,
	"./Assets/Images/breakfast1111.png": 53914,
	"./Assets/Images/dinner.jpg": 48942,
	"./Assets/Images/drinks.jpg": 14695,
	"./Assets/Images/lunch.jpg": 95468,
	"./Assets/Images/nightlife.jpg": 86667,
	"./Assets/Images/shutterstock_1154073754jpg.jpg": 85526,
	"./Assets/Images/shutterstock_348320018@3x.jpg": 24536,
	"./Assets/Images/snacks.jpg": 67671,
	"./Components/Cart": 82266,
	"./Components/Cart.js": 82266,
	"./Components/CartItems": 16252,
	"./Components/CartItems.js": 16252,
	"./Components/HeaderAllPage": 51117,
	"./Components/HeaderAllPage.js": 51117,
	"./Components/Home": 66461,
	"./Components/Home.js": 66461,
	"./Components/LogOutComponent": 20306,
	"./Components/LogOutComponent.js": 20306,
	"./Components/LoginComponent": 55845,
	"./Components/LoginComponent.js": 55845,
	"./Components/MealTypeItem": 67698,
	"./Components/MealTypeItem.js": 67698,
	"./Components/MenuItem": 30074,
	"./Components/MenuItem.js": 30074,
	"./Components/QuickSearch": 81233,
	"./Components/QuickSearch.js": 81233,
	"./Components/RestaurantDetails": 6807,
	"./Components/RestaurantDetails.js": 6807,
	"./Components/RestaurantFilter": 8194,
	"./Components/RestaurantFilter.js": 8194,
	"./Components/VrestHome2": 48046,
	"./Components/VrestHome2.js": 48046,
	"./Components/Vrestauranthome": 9219,
	"./Components/Vrestauranthome.js": 9219,
	"./Contexts/MenuCartContext": 8781,
	"./Contexts/MenuCartContext.js": 8781,
	"./Contexts/RestaurantContext": 82698,
	"./Contexts/RestaurantContext.js": 82698,
	"./Contexts/UserContext": 49213,
	"./Contexts/UserContext.js": 49213,
	"./Styles/Animation.css": 88411,
	"./Styles/CartPagecss.css": 89781,
	"./Styles/FilterpageStyle.css": 71810,
	"./Styles/HeaderAllPages.css": 88265,
	"./Styles/HeaderHome.css": 17269,
	"./Styles/Modal-menustyle.css": 80800,
	"./Styles/RestFilterMobile.css": 23585,
	"./Styles/RestaurantDetailsMobile.css": 62486,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;